var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row parametric-search-header"},[(!_vm.isPublic)?_c('div',[_c('h3',{staticClass:"page-title"},[_vm._v("My Parametric Search")])]):_vm._e(),_c('div',{staticClass:"content",class:{'description-content' : !_vm.isPublic}})])}
var staticRenderFns = []

export { render, staticRenderFns }